import { render, staticRenderFns } from "./base-input.vue?vue&type=template&id=b71b1444"
import script from "./base-input.vue?vue&type=script&lang=js"
export * from "./base-input.vue?vue&type=script&lang=js"
import style0 from "./base-input.vue?vue&type=style&index=0&id=b71b1444&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports